import { keyframes, Box } from "@chakra-ui/react";

const fadeout = keyframes`
0%{
    background: transparent;
}
16%{
    background: black;
}
84%{
    background: black;
}
100%{
    background: transparent;
}
`;

function FadeOut() {
  return (
    <Box
      bg="transparent"
      z-index="1"
      animation={`${fadeout} 1s ease-in-out`}
      position="fixed"
      top="0"
      bottom="0"
      left="0"
      right="0"
      width="100%"
      height="100%"
    />
  );
}

export default FadeOut;
